import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var msMaxWidth = 'max-width: 48rem';
  var mq = "@media only screen and (".concat(msMaxWidth, ")");
  var mp = '@media print';
  return {
    categoriesContainer: {
      display: 'flex',
      flexFlow: 'row wrap',
      position: 'relative',
      paddingTop: componentTheme.categoriesContainerPadding
    },
    categoryContainerWrapper: _defineProperty(_defineProperty({
      flexBasis: '50%',
      marginBottom: componentTheme.categoryContainerMargin
    }, mq, {
      flexBasis: '100%'
    }), '&:focus-within .keyboardHelp', {
      display: 'block'
    }),
    keyboardHelp: {
      display: 'none',
      backgroundColor: componentTheme.categoryContainerBackground,
      textAlign: 'center',
      marginRight: componentTheme.categoryContainerMargin
    },
    categoryContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: componentTheme.categoryContainerMargin,
      padding: componentTheme.categoryContainerPadding,
      backgroundColor: componentTheme.categoryContainerBackground,
      categoryContentEmpty: _defineProperty({
        flex: 1,
        color: componentTheme.emptyCategoryColor,
        textAlign: 'center',
        border: "".concat(componentTheme.emptyCategoryBorderWidth, " dashed ").concat(componentTheme.emptyCategoryBorderColor),
        borderRadius: componentTheme.emptyCategoryBorderRadius,
        height: '3.9rem',
        lineHeight: '3.9rem'
      }, mp, {
        '> *': {
          display: 'none'
        }
      }),
      categoryContentFilled: {
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        border: "".concat(componentTheme.filledCategoryBorderWidth, " solid ").concat(componentTheme.filledCategoryBorderColor),
        borderRadius: componentTheme.filledCategoryBorderRadius,
        paddingRight: componentTheme.pillMargin,
        paddingBottom: componentTheme.pillMargin,
        '> div': {
          /*
            The following !important margin is used because reactDnD forces a margin:0 inline style
            Margin is necessary instead of padding to not carry part of the background along when dragging
          */
          marginTop: "".concat(componentTheme.pillMargin, " !important"),
          marginLeft: "".concat(componentTheme.pillMargin, " !important")
        }
      }
    },
    popoverTrigger: {
      boxSizing: 'border-box',
      maxWidth: '100%',
      display: 'block',
      verticalAlign: 'middle',
      position: 'relative',
      overflow: 'visible',
      cursor: 'pointer',
      userSelect: 'none',
      touchAction: 'manipulation',
      transform: 'none',
      marginTop: componentTheme.categoryMargin,
      backgroundColor: componentTheme.categoryBackground,
      '&[aria-disabled]': {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: '0.5'
      },
      '&:focus': {
        outline: 'none',
        '&:before': {
          opacity: 1,
          transform: 'scale(1)'
        }
      },
      /* replace these stylings when instui's FocusableElement gets implemented */
      '&:before': {
        content: '""',
        position: 'absolute',
        top: '-0.25rem',
        left: '-0.25rem',
        right: '-0.25rem',
        bottom: '-0.25rem',
        border: "".concat(componentTheme.focusBorderWidth, " solid ").concat(componentTheme.focusBorderColor),
        borderRadius: "calc(".concat(componentTheme.filledCategoryBorderRadius, " + 0.125rem)"),
        transition: componentTheme.popoverTriggerBeforeTransition,
        opacity: 0,
        transform: 'scale(0.02)',
        pointerEvents: 'none'
      }
    }
  };
};
export default generateStyle;